<template>
	<div class="x-header">
		<div class="fixed-area" :style="{ background: props.color }"></div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	color?: string
}>()
</script>

<style scoped lang="scss">
.x-header {
	width: 375px;
	height: 44px;
	flex-shrink: 0;
	.fixed-area {
		position: fixed;
		top: 0;
		left: 0;
		width: 375px;
		height: 44px;
		background-color: $primaryColor;
		background-image: url('@/assets/img/navTopXQ.png');
		background-size: 100% 44px;
		background-repeat: no-repeat;
		z-index: 3;
	}
}
</style>
